module.exports = "/static/fonts/OpenSans-ExtraBold.eot";